<template>
  <el-form-item label="指标类型">
    <el-radio v-model="value" :label="item.key" v-for="(item, index) in items" :key="index">{{ item.name }}</el-radio>
    <el-radio v-if="isAll3" v-model="value" label="all3">办结情况</el-radio>
  </el-form-item>
</template>

<script>
export default {
  props: {
    value: String,
    isAll3: {
      type: Boolean,
      default: false
    },
    items: Array
  },
  watch: {
    value: {
      handler(val) {
        this.$emit('onTarget', val)
      },
      immediate: true
    }
  }
}
</script>
